import { useNavigate } from '@tanstack/react-router';
import { observer } from 'mobx-react-lite';

import { Icons } from '@/assets/icons/icons';
import { DropdownMenu } from '@/components/ui/dropdown-menu';
import { userStore } from '@/stores/user.store';

export const MeetingDebugMenuItem = observer(
  ({ meetingId }: { meetingId: string }) => {
    const navigate = useNavigate();

    if (!userStore.isInternalUser) return null;

    return (
      <DropdownMenu.Item
        className="items-center"
        onClick={(e) => {
          e.stopPropagation();
          navigate({ to: '/meeting-debug', search: { meetingId } });
        }}
      >
        <Icons.debug />
        Debug
      </DropdownMenu.Item>
    );
  }
);
